<template>
    <div class="professions-filters padding-bottom-lg">
        <div class="inner">
            <span v-if="title" class="info item">Finn ditt yrke</span>
            <div  v-if="search" class="search-hold item">
                <input  v-model="searchQuery" ref="searchInput" type="search" aria-label="Søk" :placeholder="_('Søk')" />
                <button @click="makeSearch" :aria-label="_('Søk')" class="search-icon">
                    <span v-html="searchIcon"></span>
                </button>
            </div>
            
            <v-select aria-label="Sorter på kategori" v-if="currentPostType === 'post'" v-model="category" label="name" class="archive-filters-single" placeholder="Sorter på kategori" :options="storedTaxonomy('category')"></v-select>
            <v-select aria-label="Sorter på kategori" v-if="currentPostType === 'ambassadors'" v-model="category_ambasador" label="name" class="archive-filters-single" placeholder="Sorter på kategori" :options="storedTaxonomy('category_ambasador')"></v-select>
            <template  v-if="currentPostType === 'educations' || currentPostType === 'professions' || isFrontPage">
                <v-select aria-label="Søk Utdanningsnivå" :multiple="!redirect" :class="{'is-multiple' : !redirect }" v-model="education_level" class="inputes archive-filters-single item education_level" label="name" placeholder="Utdanningsnivå" :options="storedTaxonomy('education_level')"></v-select>
                <v-select aria-label="Søk Arbeidssted" v-if="currentPostType === 'professions' || isFrontPage" :multiple="!redirect" :class="{'is-multiple' : !redirect }" v-model="work_place" class="inputes archive-filters-single item work_place" label="name" placeholder="Arbeidssted" :options="storedTaxonomy('work_place')"></v-select>
                <v-select aria-label="Hva liker du?" :multiple="!redirect" :class="{'is-multiple' : !redirect }" v-model="interests" class="inputes archive-filters-single item interests" label="name" placeholder="Hva liker du?" :options="storedTaxonomy('interests')"></v-select>
            </template>
        </div>
    </div>
</template>

<script>
import _debounce from 'lodash.debounce';
import _isEqual from 'lodash.isequal';

import { search } from '@/components/../icons';
import { mapGetters } from 'vuex';

export default {
    name: 'home-filter-links',
    props: {
        redirect: {
            type: Boolean,
            default: false,
        },
        title: {
            type: Boolean,
            default: true,
        },
        search: {
            type: Boolean,
            default: false,
        },
    },
    data(){
        return{
            education_level: '',
            category: '',
            category_ambasador: '',
            work_place: '',
            interests: '',
            searchQuery : '',
            browserNavigation : false,
            searchIcon: search('#005782'),
        }
    },
    destroyed(){
        //window.onpopstate = () => {}
    },
    mounted(){
        const VM = this
        VM.updateFilterBasedOnGivenUrl()
        // window.onpopstate = () => { 
        //     VM.browserNavigation = true;
        // };
    },
    components:{
    },
    watch: {
        '$route': function(val){
            //console.log(this.browserNavigation)
            //if(this.browserNavigation){
                this.updateFilterBasedOnGivenUrl()
                //this.browserNavigation = false;
            //}
            //this.updateFilterBasedOnGivenUrl();
        },
        isTaxonomiesLoaded(val){
            if(val){
               this.updateFilterBasedOnGivenUrl();
            }
        },
        education_level(value){
            this.archiveRedirect(value)
            this.updateQueryUrl(value, 'education_level');
            this.emitUpdateFilter(value, 'education_level');
        },
        category_ambasador(value){
            this.updateQueryUrl(value, 'category_ambasador');
            this.emitUpdateFilter(value, 'category_ambasador');
        },
        work_place(value){
            this.archiveRedirect(value)
            this.updateQueryUrl(value, 'work_place');
            this.emitUpdateFilter(value, 'work_place');
        },
        interests(value){
            this.archiveRedirect(value)   
            this.updateQueryUrl(value, 'interests');
            this.emitUpdateFilter(value, 'interests');
            
        },
        category(value){
            this.updateQueryUrl(value, 'category');
            this.emitUpdateFilter(value, 'category');
        },
        searchQuery(newVal){
            this.userTypingSearch(newVal)
        },
    },
    computed:{
        ...mapGetters([
            'currentPostType',
            'currentPage',
            'storedTaxonomy',
            'isFrontPage',
            'isArchive',
            'isTaxonomiesLoaded',
            'storedTaxonomyBySlug'
        ]),
        
    },
    methods:{
        updateFilterBasedOnGivenUrl(){
            const VM = this
            const queryTMP = Object.assign({}, this.$route.query)
            if(Object.keys(queryTMP).length){
                Object.keys(queryTMP).forEach(key=>{
                    if(key === 'search'){
                        VM.searchQuery = queryTMP[key]
                    }else{
                        const category = VM.storedTaxonomyBySlug(key, queryTMP[key].split(','))
                        if(category && Array.isArray(category)){
                            if( key=== 'interests' || key=== 'education_level' || key=== 'work_place' ){
                                VM.updateFilterValue(category, key)
                            }else{
                                category.forEach(sCat=> VM.updateFilterValue(sCat, key))
                            }
                        }
                    }
                    
                })
            }else{
                this.nullFilters();
            }
        },
        nullFilters(){
            this.education_level = ''
            this.category = ''
            this.category_ambasador = ''
            this.work_place = ''
            this.interests = ''
            this.searchQuery = ''
        },
        updateFilterValue(value, taxonomy){
            this[taxonomy] = value
        },
        emitUpdateFilter(value, taxonomy){
            if(this.redirect) return null;
            this.$emit('onChange', {'action' : taxonomy , value })
        },
        triggerSearch(){
            const value =  this.searchQuery
            this.$emit('onChange', {'action' : 'search' , value })
            this.updateQueryUrl(value, 'search')
        },
        updateQueryUrl(value, key){

            if(this.redirect) return null;
            const queryTMP = Object.assign({}, this.$route.query);
            let newQuery = {};
            if(key === 'search' && value !== ''){
                newQuery = {...queryTMP, [key] : value  }
            }else if(typeof (value) === "object" && value && value.length){
                newQuery = {...queryTMP, [key] : value.map(e => e.slug).join(',')  }
            }else if(value && value.slug){
                newQuery = {...queryTMP, [key] : value.slug  }
            }else{
                newQuery = {...queryTMP }
                if(newQuery.hasOwnProperty([key])){
                    delete newQuery[key]
                }
            }
            if(!_isEqual(queryTMP, newQuery)){
                this.$router.push({ query: newQuery })
            }
        },
        clearFilters(){
            console.log('clear Filters')
        },
        clearSearch(){
            console.log('clear search')
        },
        userTypingSearch: _debounce(function (value) {
            this.triggerSearch();
        }, 250),
        makeSearch(){
            this.triggerSearch();
        },
        archiveRedirect(value){
            if(!this.redirect) return null;
            if(window.WPVUE && window.WPVUE.options && window.WPVUE.options.archive_professions && value){
                const { slug, id } = window.WPVUE.options.archive_professions
                const key = value.type
                this.$router.push({ path: '/'+slug, query: {  [key] : value.slug  } }) 
               
            }
        }
    }
};
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";

.professions-filters{
    position: relative;
    background-color: $darkLight;
    max-width: 800px;
    input[type="search"]::-webkit-search-decoration,
    input[type="search"]::-webkit-search-cancel-button,
    input[type="search"]::-webkit-search-results-button,
    input[type="search"]::-webkit-search-results-decoration {
        -webkit-appearance:none;
    }
    &:after, &:before{
        content: '';
        position: absolute;
        z-index: 10;
        top: 0;
        bottom: 0;
        background-color: $darkLight;
        width: 50vw;
        @include mquery($phone){
            width: 16px;
        }
    }
    &:after{
        left: 1px;
        transform: translateX(-100%);
    }
    &:before{
        right: 1px;
        transform: translateX(100%);
    }
    &.on-archive{
        .inner{
            background: transparent;
            padding: 0;
            display: flex;
            .archive-filters-single{
                width: 100%;
            }
            .item{
                margin-right: 25px;
                &:last-child{
                    margin-right: 0;
                }
            }
            @include mquery($phone){
                flex-wrap: wrap;
                padding-left: 15px;
                padding-right: 15px;
                .item{
                    max-width: 100%;
                    margin-right: 0;
                    margin-top: 15px;
                }
            }
        }
        
    }
    &.home-filter{
        .inner{
            color: $darkLight;
            border-radius: 40px;
            padding: 12px 20px;
            background: #fff;
            display: flex;
            width: 100%;
            align-items: baseline;
            @include fluid-type($smallResText, $wideResText, 16px, 18px);
            @include mquery($phone){
                flex-wrap: wrap;
                padding: 0;
                background-color: transparent;
                .info{
                    padding: 5px 10px;
                }
                .inputes, .info{
                    background-color: #fff;
                    margin-bottom: 15px;
                    border-radius: $blocksRadius;
                    width: 100% !important;
                    padding-top: 5px;
                    padding-bottom: 5px;
                }
            }
            .inputes{
                //flex: 1 0 auto;
                position: relative;
                width: 205px;
                &.work_place{
                }
                /* &:before{
                    content: '';
                    width: 1px;
                    position: absolute;
                    left: 0;
                    top: 40%;
                    bottom: 40%;
                    background: $darkLighten;
                } */
                &.vs--open{
                    .vs__selected-options{
                        .vs__selected{
                            ~ .vs__search{
                                display: block;
                            }
                        }
                    }
                }
            }
            .vs__dropdown-toggle{
                border: none;
                padding:0;
                height: 26px;
            }
            .vs__search{
                white-space: nowrap;
                margin: 0;
                width: 100%;
                padding-left: 20px;
                padding-right: 15px;
                cursor: pointer;
            }
            .vs__dropdown-option{
                //color: $darkLight;
            }
            .vs__actions{
                cursor: pointer;
            }
            .vs__selected-options{
                color: $darkLight;
                .vs__selected{
                    margin: 0;
                    ~ .vs__search{
                        //display: none;
                    }
                }
                input{
                    color: inherit;
                    &::placeholder{
                        color: inherit;
                    }
                }
            }
            .vs__open-indicator{
                fill: $darkLight;
            }
        }
    }
    .search-hold{
        color: $dark;
        position: relative;
        width: 100%;
        input{
            padding: 16px 25px;
            background-color: #fff;
            border: none;
            border-radius: 50px;
            width: 100%;
            padding-right: 40px;
            &::placeholder{
                color: $darkLight
            }
        }
        .search-icon{
            position: absolute;
            box-shadow: none;
            top: 50%;
            right: 25px;
            border: none;
            padding: 0;
            margin: 0;
            background: transparent;
            transform: translateY(-50%);
            svg{
                width: 20px;
                height: 20px;
            }
        }
    }
    .info{
        font-weight: bold;
        padding-right: 20px;
        white-space: nowrap;
    }

    
}
</style>